/**
 * Tabular Layout Options
 * 
 * Options panel for configuring the table layout.
 */

import { Label } from '@/components/ui/label';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import type { LayoutOptionsProps, TabularLayoutOptions } from '../types';

export function TabularOptions({
    layoutOptions,
    onLayoutOptionsChange,
}: LayoutOptionsProps<TabularLayoutOptions>) {

    const handleSpacingChange = (spacing: 'compact' | 'cozy' | 'comfortable') => {
        onLayoutOptionsChange({ ...layoutOptions, spacing });
    };

    // Get current spacing value, default to 'cozy'
    const currentSpacing = layoutOptions.spacing || 'cozy';

    return (
        <div className="space-y-4">
            <div className="space-y-2">
                <Label className="text-xs text-muted-foreground">Spacing</Label>
                <Select
                    key={currentSpacing}
                    value={currentSpacing}
                    onValueChange={handleSpacingChange}
                >
                    <SelectTrigger className="w-full">
                        <SelectValue placeholder="Select spacing" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="compact">Compact</SelectItem>
                        <SelectItem value="cozy">Cozy</SelectItem>
                        <SelectItem value="comfortable">Comfortable</SelectItem>
                    </SelectContent>
                </Select>
            </div>
        </div>
    );
}
